<div class="asic-documents-container">
  <div class="title-container">
    <h3>ASIC Response</h3>
  </div>

  <div class="d-flex flex-column gap-24">
    @if(notLodgedForm) {
      <app-notification
        [color]="'orange'"
        [title]="'Disclaimer'"
        [text]="notLodgedFormMsg"
      ></app-notification>
    } @else {
      @if(document.asicStatus === AsicStatus.Lodged) {
        <app-notification
          [iconClass]="'icon ic-checkmark-circle-20'"
          [color]="'green'"
          [title]="'Successful Lodgement'"
          [text]="successMsg"
          [amount]="document.asicDocumentNumber || document.asicTraceNumber || ''"
          [isMoneyFormat]="false"
        ></app-notification>

        <div class="btn-container">
          <app-button
            [text]="'Request Correction'"
            [iconClass]="'icon ic-form-edit-20'"
            [btnColor]="'white'"
            (clickBtn)="requestCorrection()"
          ></app-button>

          <app-button
            [text]="'Withdraw'"
            [iconClass]="'icon ic-refresh-20'"
            [btnColor]="'white'"
            (clickBtn)="withdraw()"
          ></app-button>
        </div>
      } @else if(document.asicStatus === AsicStatus.Rejected) {
        <app-notification
          [iconClass]="'icon ic-cancel-circle-20'"
          [color]="'red'"
          [title]="'Rejected Lodgement'"
          [text]="rejectedMsg"
        >
          <div>To edit the data, <a class="red" (click)="editInitialDocument()">click here.</a></div>
        </app-notification>

        <div class="btn-container">
          <app-button
            [text]="'Edit Document'"
            [iconClass]="'icon ic-edit-20'"
            [btnColor]="'white'"
            (clickBtn)="editInitialDocument()"
          ></app-button>

          <app-button
            [text]="'Delete Document'"
            [iconClass]="'icon ic-trash-20'"
            [btnColor]="'white'"
            (clickBtn)="deleteDocument()"
          ></app-button>
        </div>

        <div class="error-container">
          @for(item of document.edgeValidationResult?.validationErrors; track $index) {
            <div class="error-row">
              <div><i class="icon ic-arrow-right-20"></i></div>
              <div class="error-wrapper">
                <div class="title">{{item.code}}</div>
                @if(item.description) {
                  <div class="error-text" [innerHtml]="item.description | replaceStr: '\n' : '<br>'"></div>
                }
              </div>
            </div>
          }
        </div>
      } @else if(document.asicStatus === AsicStatus.Pending) {
        <app-notification
          [iconClass]="'icon ic-clock-20'"
          [color]="'blue'"
          [title]="'Lodgement is Pending'"
          [text]="'The form is on queue to be transmitted to ASIC'"
        ></app-notification>
      } @else if(document.asicStatus === AsicStatus.WaitingForASIC) {
        <app-notification
          [iconClass]="'icon ic-timer-20 orange'"
          [color]="'orange'"
          [title]="'Waiting for ASIC'"
          [text]="'The form has been successfully transmitted and now waiting for ASIC response.'"
        ></app-notification>
      } @else if(document.asicStatus === AsicStatus.ManualProcessing) {
        <app-notification
          [iconClass]="'icon ic-pause-circle-20'"
          [color]="'purple'"
          [title]="'Manual Processing'"
          [text]="'Lodgement is currently on hold with ASIC. Waiting for update from ASIC.'"
        ></app-notification>
      } @else if(document.asicStatus === AsicStatus.MarkedAsLodged) {
        <app-notification
          [iconClass]="'icon ic-checkmark-circle-20'"
          [color]="'green'"
          [title]="'Marked as Lodged'"
          [text]="markedAsLodgedMsg"
          [amount]="document.asicDocumentNumber || document.asicTraceNumber || ''"
          [isMoneyFormat]="false"
        ></app-notification>
      }@else {
        <app-notification
          [iconClass]="'icon ic-info-circle-20'"
          [title]="AsicStatus[document.asicStatus]"
          [text]="AsicStatus[document.asicStatus]"
        ></app-notification>
      }
    }
  </div>
</div>
